'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * FieldAffixes component, used to wrap a form field.
 *
 * @example
 * <Field.Affixes>
 *   <Field.Affix>NOK</Field.Affix>
 *   <Input />
 *   <Field.Affix>pr. mnd.</Field.Affix>
 * </Field.Affixes>
 */
const FieldAffixes = forwardRef(function FieldAffixes({ className, ...rest }, ref) {
    return (jsx("div", { className: cl('ds-field-affixes', className), ref: ref, ...rest }));
});
/**
 * FieldAffix component, used to wrap a form field.
 * Use together with Field.Affixes.
 *
 * @example
 * <Field.Affixes>
 *   <Field.Affix>NOK</Field.Affix>
 *   <Input />
 *   <Field.Affix>pr. mnd.</Field.Affix>
 * </Field.Affixes>
 */
const FieldAffix = forwardRef(function FieldAffix({ className, ...rest }, ref) {
    return (jsx("span", { className: cl('ds-field-affix', className), "aria-hidden": 'true', ref: ref, ...rest }));
});

export { FieldAffix, FieldAffixes };
